import { L10n } from '../L10n/L10n';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ISchedule, ScheduleActions } from '../../schedule/types/ISchedule';
import { IScheduleInfo } from '../../schedule/types/IScheduleInfo';

export class DeleteSchedulesAction {

  public static $inject = ['$translate'];

  constructor(
    private $translate: ng.translate.ITranslateService) { }

  public deleteSingleScheduleBodyText(schedule: IScheduleInfo): string {
    const scheduleSet = Set.singletonForIdItem(schedule);
    const extractTaskCount = this.countExtractTasks(scheduleSet);
    const subscriptionScheduleCount = this.countSubscriptionSchedules(scheduleSet);
    const runFlowTaskCount = this.countFlowTasks(scheduleSet);

    if (subscriptionScheduleCount > 0) {
      return this.$translate.instant('confirmDeleteSubscriptionSchedule', {
        SCHEDULE_NAME: L10n.elideIfLong(schedule.name)
      });
    } else if (runFlowTaskCount > 0) {
      return this.$translate.instant('confirmDeleteRunFlowTaskSchedule', {
        SCHEDULE_NAME: L10n.elideIfLong(schedule.name),
        FLOW_COUNT: runFlowTaskCount
      }, L10n.Interpolations.Count);
    } else {
      return this.$translate.instant('confirmDeleteExtractRefreshSchedule', {
        SCHEDULE_NAME: L10n.elideIfLong(schedule.name),
        EXTRACT_COUNT: extractTaskCount
      }, L10n.Interpolations.Count);
    }
  }

  // returns the number of extract tasks in the given set of schedules
  private countExtractTasks(schedules: Set<ISchedule>) {
    return schedules.reduce(
      (sum: number, s: ISchedule) => sum + (s.scheduledAction === ScheduleActions.Extract ? s.taskCount : 0), 0);
  }

  // returns the number of subscription schedules in the given set of schedules
  private countSubscriptionSchedules(schedules: Set<ISchedule>) {
    return schedules.reduce(
      (sum: number, s: ISchedule) => sum + (s.scheduledAction === ScheduleActions.Subscription ? 1 : 0), 0);
  }

    // returns the number of flow tasks in the given set of schedules
    private countFlowTasks(schedules: Set<ISchedule>) {
      return schedules.reduce(
        (sum: number, s: ISchedule) => sum + (s.scheduledAction === ScheduleActions.Flow ? s.taskCount : 0), 0);
      }

}

Module.instance().service('DeleteSchedulesAction', DeleteSchedulesAction);
